import React, { FunctionComponent } from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import {
  DarkButton,
  defaultButtonStyles,
} from '../../../../../components/V2/Buttons';

interface TimezoneAlertModalProps {
  open: boolean;
  userTimezone: string;
  onClose: () => void;
  onUpdateTimezone: () => void;
}

const TimezoneAlertModal: FunctionComponent<TimezoneAlertModalProps> = ({
  open,
  userTimezone,
  onClose,
  onUpdateTimezone,
}) => {
  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: { borderRadius: '20px' },
      }}
    >
      <DialogTitle
        sx={{
          m: 0,
          p: { xs: '15px', sm: '30px' },
          color: '#000000',
          fontWeight: 600,
          fontSize: '16px',
        }}
      >
        Timezone
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: 'absolute',
          right: { xs: '7px', sm: '22px' },
          top: { xs: '7px', sm: '22px' },
        }}
      >
        <CloseIcon sx={{ color: '#000000' }} />
      </IconButton>
      <DialogContent sx={{ p: { xs: '0 15px', sm: '0 30px' } }}>
        <div>
          <Typography>
            Selected user is in a different timezone, Would you like to update
            your timezone to <b>{userTimezone}</b>
          </Typography>
        </div>
      </DialogContent>
      <DialogActions sx={{ p: { xs: '15px', sm: '30px' } }}>
        <DarkButton
          disableElevation
          variant="contained"
          color="inherit"
          sx={{ ...defaultButtonStyles }}
          onClick={onUpdateTimezone}
        >
          Update
        </DarkButton>
      </DialogActions>
    </Dialog>
  );
};

export default TimezoneAlertModal;
